import { render, staticRenderFns } from "./RegisteredPersonnel.vue?vue&type=template&id=193ff486&scoped=true"
import script from "./RegisteredPersonnel.vue?vue&type=script&lang=js"
export * from "./RegisteredPersonnel.vue?vue&type=script&lang=js"
import style0 from "./RegisteredPersonnel.vue?vue&type=style&index=0&id=193ff486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ff486",
  null
  
)

export default component.exports